import { useState } from 'react';
import { useFormikContext } from 'formik';
import { Field } from 'formik';

import { InputUI, FormLabelUI, FormErrorUI, TabsUI, FileTabUI } from '../Interface';
import ServiceMaterial from './ServiceMaterial';
import ServiceTask from './ServiceTask';
import ServiceTaskCheckList from './ServiceTaskCheckList';
import ServiceAccounting from './ServiceAccounting';
import { FormType } from '../../config/form';

const DescriptionPanel = (props) => {
  const { disabled } = props;
  const { values, errors } = useFormikContext();

  return (
    <div className="col-span-full relative">
      <Field
        type="text"
        name="description"
        as={InputUI}
        className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
        fullWidth
        label={<FormLabelUI text="Leírás" />}
        variant="standard"
        helperText={<FormErrorUI message={errors.description} />}
        disabled={disabled}
        InputLabelProps={{ shrink: values.description && values.description !== '' }}
        multiline
        rows={4}
      />
    </div>
  );
};

const ServiceTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedValues } = props.selectedValuesState;

  const tabs = [
    {
      id: 0,
      name: 'Feladat',
      content: <ServiceTask {...props} />,
    },
    {
      id: 1,
      name: 'Alapanyag',
      content: <ServiceMaterial {...props} />,
    },
    {
      id: 2,
      name: 'Checklist',
      content: <ServiceTaskCheckList {...props} />,
    },

    {
      id: 3,
      name: 'Leírás',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 4,
      name: 'Kiadás/bevételezés',
      content: <ServiceAccounting {...props} />,
    },
    {
      id: 5,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={selectedValues?.attachments ?? []}
          disabled={props.disabled}
          parentObj={FormType.SERVICE}
        />
      ),
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ServiceTabs;
